import Badge from "../components/Badge";
import BaseAlert from "../components/BaseAlert";
import BaseButton from "../components/BaseButton";
import BaseCheckbox from "../components/BaseCheckbox";
import BaseInput from "../components/BaseInput";
import BaseInputFile from "../components/BaseInputFile";
import BaseDropdown from "../components/BaseDropdown";
import BaseNav from "../components/BaseNav";
import BasePagination from "../components/BasePagination";
import BaseProgress from "../components/BaseProgress";
import BaseRadio from "../components/BaseRadio";
import BaseSlider from "../components/BaseSlider";
import BaseSwitch from "../components/BaseSwitch";
import BaseTable from "../components/BaseTable";
import BaseHeader from "../components/BaseHeader";
import BaseFooter from "../components/BaseFooter";
import Card from "../components/Card";
import StatsCard from "../components/StatsCard";
import Modal from "../components/Modal";
import TabPane from "../components/Tabs/TabPane";
import Tabs from "../components/Tabs/Tabs";
import SvgIcon from "../components/SvgIcon";
import FloatingLabel from "../components/FloatingLabel";
import BaseLoader from "../components/BaseLoader";
import BaseCard from "../components/BaseCard";
import PageTitle from "../components/PageTitle";
import InfoMessage from "../components/InfoMessage";
import ImageBox from "../components/ImageBox";
import StepNav from "../components/StepNav";
import BaseModel from "../components/BaseModel";

export default {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseInputFile.name, BaseInputFile);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSlider.name, BaseSlider);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(BaseTable.name, BaseTable);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(BaseFooter.name, BaseFooter);
    Vue.component(Card.name, Card);
    Vue.component(StatsCard.name, StatsCard);
    Vue.component(Modal.name, Modal);
    Vue.component(TabPane.name, TabPane);
    Vue.component(Tabs.name, Tabs);
    Vue.component(SvgIcon.name, SvgIcon);
    Vue.component(FloatingLabel.name, FloatingLabel);
    Vue.component(BaseLoader.name, BaseLoader);
    Vue.component(BaseCard.name, BaseCard);
    Vue.component(PageTitle.name, PageTitle);
    Vue.component(InfoMessage.name, InfoMessage);
    Vue.component(ImageBox.name, ImageBox);
    Vue.component(StepNav.name, StepNav);
    Vue.component(BaseModel.name, BaseModel);
  }
};
